<script setup lang="ts">
import UiShareUrl from 'ui-toolkit/components/UiShareUrl.vue';
import BaseButton from '@/components/base-button/BaseButton.vue';
import ShareIcon from '@/assets/icons/24px/share.svg?component';
import TickIcon from '@/assets/icons/24px/tick.svg?component';
</script>

<template>
  <UiShareUrl v-slot="{ copied }">
    <BaseButton
      class="shareButton"
      :icon="copied ? TickIcon : ShareIcon"
    >
      {{ copied ? 'Copied' : 'Share' }}
    </BaseButton>
  </UiShareUrl>
</template>

<style lang="scss" scoped>
.shareButton {
  position: relative;
  display: flex;
  align-items: center;
}
</style>
